import { type IconProp } from '@fortawesome/fontawesome-svg-core';

export type MapStatusBarToggleSwitchItem = {
  label: string;
  isVisible: boolean;
  onVisibilityChange: (isVisible: boolean) => void;
  switch: {
    offIcon: IconProp;
    onIcon: IconProp;
  };
};

export enum MapStatusBarItemRemoveType {
  DeletePermanently = 'DeletePermanently',
  RemoveFromMap = 'RemoveFromMap',
  Undo = 'Undo',
}

export type MapStatusBarLabelItem = {
  icon?: IconProp;
  label: string;
  isVisible?: boolean;
  onRemove?: () => void;
  onVisibilityChange?: (isVisible: boolean) => void;
  onClick?: () => void;
  removeType: MapStatusBarItemRemoveType | null;
};

export type MapStatusBarItem = MapStatusBarToggleSwitchItem | (MapStatusBarLabelItem & {
  switch?: undefined;
});
